export interface Address {
  lat: number;
  lng: number;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  country: string;
  zip: number;
  fullAddress: string;
}

export interface OpenStreetMapAddress {
  place_id: number;
  licence: string;
  osm_type: string;
  osm_id: number;
  lat: string;
  lon: string;
  class: string;
  type: string;
  place_rank: number;
  importance: number;
  addresstype: string;
  name: string;
  display_name: string;
  address: {
    neighbourhood: string;
    suburb: string;
    city: string;
    state: string;
    road: string;
    'ISO3166-2-lvl4': string;
    country: string;
    country_code: string;
  };
  boundingbox: string[];
}
